import React from "react";
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaNodeJs,
  FaPython,
  FaJava,
} from "react-icons/fa";
import {
  SiExpress,
  SiTailwindcss,
  SiMongodb,
  SiPandas,
  SiNumpy,
  SiPowerbi,
  SiMysql,
} from "react-icons/si";

const techIcons = [
  { icon: <FaHtml5 />, name: "HTML" },
  { icon: <FaCss3Alt />, name: "CSS" },
  { icon: <FaJs />, name: "JavaScript" },
  { icon: <FaReact />, name: "React.js" },
  { icon: <FaNodeJs />, name: "Node.js" },
  { icon: <SiExpress />, name: "Express.js" },
  { icon: <SiMongodb />, name: "MongoDB" },
  { icon: <SiTailwindcss />, name: "TailwindCSS" },
  { icon: <FaPython />, name: "Python" },
  { icon: <SiPandas />, name: "Pandas" },
  { icon: <SiNumpy />, name: "NumPy" },
  { icon: <SiPowerbi />, name: "Power BI" },
  { icon: <FaJava />, name: "Java" },
  { icon: <SiMysql />, name: "SQL" },
];

const TechSlider = () => {
  return (
    <div className="w-full bg-gradient-to-r from-[#406FCC] to-[#4A3FBF] py-4 lg:py-6 overflow-hidden">
      <div className="relative">
        <div className="flex items-center gap-12 whitespace-nowrap animate-marquee">
          {[...techIcons, ...techIcons].map((tech, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="text-white text-3xl lg:text-4xl">
                {tech.icon}
              </span>
              <span className="text-white text-lg md:text-xl lg:text-2xl font-medium">
                {tech.name}
              </span>
              <span className="text-white/60 text-lg md:text-xl lg:text-2xl select-none">
                /
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechSlider;
